<div
    (click)="clickAction()"
    [class.overlay]="overlay"
    [class.svg-shadow]="shadow"
    class="topbar-logo curpoint"
>
    @if (!full && !dark) {
        <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_b-rood.svg">
    } @else if (full && !dark) {
        <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_bw-rood.svg">
    } @else if (!full && dark) {
        <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_b_wit-rood.svg">
    } @else if (full && dark) {
        <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_bw_wit-rood.svg">
    }
</div>
